<kendo-card width="100%" class="profile-card">
  <kendo-card-header class="k-hstack">
    <div class="row">
      <div class="col-12 col-lg-2">
        <span
          >Threat Profile
          <br />
        </span>
      </div>
      <div class="col-12 col-lg-12">
        <threat-header>
          <header-title
            ><a routerLink="/research/threat-profile/{{ data.UUID }}">
              {{ data.title }}</a
            >
          </header-title>
          <header-options>
            <i
              *ngIf="favorited"
              class="k-icon k-font-icon k-i-bookmark-outline favorite"
              (click)="unfavorite()"
            ></i>
            <i
              *ngIf="!favorited"
              class="k-icon k-font-icon k-i-bookmark favorite"
              (click)="favorite()"
            ></i>
          </header-options>
        </threat-header>
        <div class="profile-content">
          <profile-description>
            {{ data.overview }}
            <ul>
              <li *ngIf="data?.also_known_as.length > 0">
                <span>Also Known As</span>
                <p>{{ data?.also_known_as.join(', ') }}</p>
              </li>
              <li>
                <span>Impact</span>
                <p>{{ data?.impact }}</p>
              </li>
              <li>
                <span>Threat Category</span>
                <p>{{ data?.context?.threat_categories }}</p>
              </li>
              <li>
                <span>Motivation</span>
                <p>{{ data?.context?.motivations }}</p>
              </li>
            </ul>
            <cyborg-facet-buttons
              class="tile-facets"
              [facets]="tags"
              [groupByCategory]="false"
            ></cyborg-facet-buttons>
          </profile-description>
        </div>
      </div>
    </div>
  </kendo-card-header>
</kendo-card>
